import { ACU_FUNCTIONS, ACU_TYPES } from "./acuSpec"
import { EB_FUNCTIONS, EB_TYPES } from "./ebSpec"
import { IS_MODULE_NOT_PRESENT } from "./hpSpec"
import { HpDeviceFormData } from "../types/providerTypes"

const SHARED_HIDDEN_FIELD_DEFAULTS: Partial<HpDeviceFormData> = {
    deviceIsBackUpHeaterPresent: IS_MODULE_NOT_PRESENT,
    deviceBackUpHeaterPhases: null,
    deviceBackUpHeaterModuleRef: "",
    deviceBackUpHeaterModule: null,
    deviceBackUpHeaterModuleInputRatedCurrent: null,
    deviceBackUpHeaterModuleInputRatedPower: null,
    deviceIsBoostHeaterPresent: IS_MODULE_NOT_PRESENT,
    deviceBoostHeaterPhases: null,
    deviceBoostHeaterModuleRef: "",
    deviceBoostHeaterModule: null,
    deviceBoostHeaterModuleInputRatedCurrent: null,
    deviceBoostHeaterModuleInputRatedPower: null,
    deviceIsWaterHeaterPresent: IS_MODULE_NOT_PRESENT,
    deviceWaterHeaterPhases: null,
    deviceWaterHeaterModuleRef: "",
    deviceWaterHeaterModule: null,
    deviceWaterHeaterModuleInputRatedCurrent: null,
    deviceWaterHeaterModuleInputRatedPower: null,
    deviceIsHeatPumpModulePresent: IS_MODULE_NOT_PRESENT,
    deviceHeatPumpModulePhases: null,
    deviceHeatPumpModuleRef: "",
    deviceHeatPumpModule: null,
    deviceHeatPumpModuleInputRatedCurrent: null,
    deviceHeatPumpModuleInputRatedPower: null,
    deviceNomCurrentW35: null,
    deviceNomCurrentW45: null,
    deviceNomCurrentW55: null,
    deviceNomCurrentW65: null,
}

export const EB_HIDDEN_FIELD_DEFAULTS: Partial<HpDeviceFormData> = {
    ...SHARED_HIDDEN_FIELD_DEFAULTS,
    function: EB_FUNCTIONS[0],
    heatPumpType: EB_TYPES[0],
    deviceModule: "N/A",
    deviceModuleRef: "N/A",
    deviceHarmonicStandards: "N/A",
}

export const ACU_HIDDEN_FIELD_DEFAULTS: Partial<HpDeviceFormData> = {
    ...SHARED_HIDDEN_FIELD_DEFAULTS,
    function: ACU_FUNCTIONS[0],
    heatPumpType: ACU_TYPES[0],
    deviceModule: "N/A",
    deviceModuleRef: "N/A",
}
